<script>
import Layout from '../../layouts/main';
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import RentalCustomerInfo from './Form/RentalCustomerInfo';
import RentalVehicleInfo from './Form/RentalVehicleInfo';
import Swal from 'sweetalert2';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import rentalCustomerService from '../../../api/rentalCustomerService';

export default {
  components: {
    Layout,
    RentalCustomerInfo,
    RentalVehicleInfo,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      progress: [
        {
          title: 'Customer Information',
          icon: 'uil-user',
        },
        {
          title: 'Vehicle & Rental Details',
          icon: 'uil-car',
        },
      ],
      form: null,
      formStatus: 0,
      loaded: true
    };
  },
  computed: {
    onEditId() {
      return this.$route.query.id;
    },
    formWizard() {
      return this.$refs.formWizard;
    },
    role_id() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      
      return userData? userData.role_id : null
    },
    edit_permission() {
      const editable = [1,2]
      return !editable.includes(this.role_id)
    }
  },
  methods: {
    beforeChange() {
      return false
    },
    handleStepChange() {
      return new Promise((resolve, reject) => {
        reject()
     })
    },
    async saveRentalCustomer() {
      Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
      });
    },
    async getData() {
      this.loaded = false
      //Loading Swal
      Swal.fire({
        title: 'Loading...',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
        showConfirmButton: false,
      });

      this.form = await rentalCustomerService.show(this.onEditId)
      
      setTimeout(() => {
        Swal.close()
      }, 1000);

      this.loaded = true
    }
  },
  async mounted() {
    if (this.onEditId) {
      this.getData()
    }
  }
};
</script>

<template>
  <Layout>
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Rental Customer Information: {{ form?.name }}</h4>
          <form-wizard v-if="loaded" :startIndex="formStatus" refs="form-wizard" color="#5b73e8">
            <tab-content v-for="({ title, icon }, i) in progress" :title="title" :icon="icon" :key="i">
              <div class="row">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">{{ title }}</h4>
                      <div class="mt-4">
                        <div v-if="i === 0">
                          <RentalCustomerInfo
                            :edit_permission="edit_permission"
                            :form_data="form"
                            :getData="getData"
                            @refresh="getData"
                          />
                        </div>
                        <div v-if="i === 1">
                          <RentalVehicleInfo
                            :edit_permission="edit_permission"
                            :form_data="form?.rentalVehicles && form.rentalVehicles.length > 0 ? form.rentalVehicles[0] : {}"
                            :rental_customer_id="onEditId"
                            :getData="getData"
                            @refresh="getData"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
.wizard-card-footer {
  display: none;
}
.boxed {
  border: 5px solid #ebeff2;
  border-radius: 8px;
  padding: 10px;
  height: 75px;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
